var React = require('react');

function AngleInline (props) {
    return React.createElement("svg",props,React.createElement("g",{"data-name":"Group 1"},React.createElement("path",{"d":"M11.49 5.397l8.6 8.3a1.318 1.318 0 0 1 0 1.911 1.437 1.437 0 0 1-1.981 0L10.5 8.263l-7.609 7.34a1.437 1.437 0 0 1-1.981 0 1.318 1.318 0 0 1 0-1.911l8.6-8.3a1.436 1.436 0 0 1 1.98 0z"})));
}

AngleInline.defaultProps = {"viewBox":"0 0 21 21"};

module.exports = AngleInline;

AngleInline.default = AngleInline;
